<template>
  <div class="contentWrap  boxed">
    <div class="d2-section">
        <div class="loginPanel">
          <form v-on:submit.prevent="login">
            <h2 class="d2-h2 ">{{$t("login_title")}}</h2>
            <h4 class="d2-h4">
              {{$t("confirmation")}}
            </h4>
            <div class="d2-inputWrap">
              <input
                type="tel"
                class="mobiForElm__input"
                v-model="msisdn"
                maxlength="14"
                placeholder
              />
            </div>
            <div class="d2-inputWrap d2-btnContainer">
              <button type="submit" class="d2-button lg">{{$t("submit")}}</button>
            </div>
            <div
              v-if="showStatusAlert"
              class="d2-inputWrap"
              role="alert"
            >
              <span v-if="lang_gamebox === 'english'">{{ status }}</span>
              <span v-if="lang_gamebox !== 'english'">{{ statusTran }}</span>
              <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close" @click="close()">×</a>
            </div>
            <div
              v-if="showMsisdnAlert"
              class="d2-inputWrap d2-alert "
              role="alert"
            >
              {{$t("valid_number")}}
              <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close" @click="close()">×</a>
            </div>
          </form>
        </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";
import gamebox from "../../../router/gamebox";
import country_list from "../../../locales/country_list.json";
import EventBus from "../../EventBus.vue";
import { mapActions, mapGetters } from "vuex";

const proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

export default {
  data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"
    };
  },
  created() {
    this.getPrefix(this.country_gamebox);
  },
  computed: mapGetters(["lang_gamebox", "gcid_gamebox", "country_gamebox"]),
  methods: {
    getPrefix(country) {
      for (let [key, value] of Object.entries(country_list)) {
        if (country == key) {
          this.msisdn = "+" + value.prefix;
        }
      }
    },
    close() {
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login() {
      let regex = /^\d{9,}$/;
      let a = this.msisdn;
      this.msisdn = a.replace("+", "");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          let gcid = "";
          if (this.gcid_gamebox != "") {
            gcid = this.gcid_gamebox;
          } else {
            gcid = "264";
          }

          let data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          const login = {
            url: `${proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=${data.msisdn}&gcid=${data.gcid}&verbose=${data.verbose}`),
            method: "POST"
          };
          this.$axios(login)
            .then(res => {
              var response = JSON.parse(res.data.contents);
              if (response == "active") {
                localStorage.setItem("userToken_gamebox", response.token);
                localStorage.setItem(
                  "userProfile_gamebox",
                  res.data.contents
                );
                this.msisdn = "";
                // this.emitMethod();
                this.login_gamebox("loggedin");
                gamebox.push({ name: "Main" }).catch(err => {});
                location.reload();
              } else if (response.status == "inactive") {
                this.showStatusAlert = true;
                this.showMsisdnAlert = false;
                let status = response.status.replace( response.status.toUpperCase());
                this.status = status;

                for (let [key, value] of Object.entries(country_list)) {
                  if (this.country_gamebox == key) {
                    let status_lang = require(`../../../locales/gamebox/${value.language}.json`);
                    this.statusTran = status_lang.status;
                  }
                }
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      }
    },
    ...mapActions(["login_gamebox"])
    // emitMethod() {

    // }
  }
};
</script>

<style lang="scss" scoped>
.loginPanel {
  max-width: 580px;
  padding: 25px;
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 5px;
  .d2-h2,
  .d2-h4 {
    color: #000;
    text-align: center;
  }
}

.d2-alert {
  position: relative;
  .close {
    float: none;
    right: 12px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/gamebox/Login.vue